import { defineComponent as o, openBlock as l, createBlock as t, unref as d, mergeProps as i, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const c = /* @__PURE__ */ o({
  name: "IconCameraViewfinder",
  __name: "IconCameraViewfinder",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const r = n;
    return (u, a) => (l(), t(d(m), i(r, { "view-box": "0 0 24 24" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("path", { d: "M3.75 4.5A.75.75 0 0 1 4.5 3.75H7a.75.75 0 0 0 0-1.5H4.5A2.25 2.25 0 0 0 2.25 4.5V7a.75.75 0 0 0 1.5 0V4.5M4.5 20.25a.75.75 0 0 1-.75-.75V17a.75.75 0 0 0-1.5 0v2.5a2.25 2.25 0 0 0 2.25 2.25H7a.75.75 0 0 0 0-1.5H4.5m12.5 0h2.5a.75.75 0 0 0 .75-.75V17a.75.75 0 0 1 1.5 0v2.5a2.25 2.25 0 0 1-2.25 2.25H17a.75.75 0 0 1 0-1.5M20.25 4.5V7a.75.75 0 0 0 1.5 0V4.5a2.25 2.25 0 0 0-2.25-2.25H17a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 1 .75.75" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M9.25 12.75a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0M12 11.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "m8.492 8 .686-1.714a1.25 1.25 0 0 1 1.16-.786h3.324a1.25 1.25 0 0 1 1.16.786L15.508 8H16.5a2.25 2.25 0 0 1 2.25 2.25v5a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-5A2.25 2.25 0 0 1 7.5 8h.992m1.616 0 .4-1h2.984l.4 1h-3.784M7.5 9.5a.75.75 0 0 0-.75.75v5A.75.75 0 0 0 7.5 16h9a.75.75 0 0 0 .75-.75v-5A.75.75 0 0 0 16.5 9.5h-9",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  c as default
};
